export function tabbingAccessibility(event, focusableRefs, isOpen) {
  var _focusable$nextIndex;
  if (event.key !== 'Tab') return;
  var focusable = focusableRefs.current;
  if (!focusable.length) return;
  var activeElement = document.activeElement;
  var currentIndex = activeElement ? focusable.indexOf(activeElement) : -1;
  if (isOpen) {
    event.preventDefault();
  }
  var direction = event !== null && event !== void 0 && event.shiftKey ? -1 : 1;
  var nextIndex = currentIndex + direction;
  if (nextIndex < 0) nextIndex = focusable.length - 1;
  if (nextIndex >= focusable.length) nextIndex = 0;
  (_focusable$nextIndex = focusable[nextIndex]) === null || _focusable$nextIndex === void 0 || _focusable$nextIndex.focus();
}